import { createAction, props } from '@ngrx/store';
import * as moment from 'moment/moment';
import { SchoolActivityScheduleType } from '../../../models';
import { SchoolActivityInstanceOverview } from '../../../services/flex-daily-overview.service';

export const GetSchoolActivityInstancesOverviewSuccessAction = createAction(
	'[SchoolActivities] Get SchoolActivityInstancesOverview Success',
	props<{ instances: SchoolActivityInstanceOverview[]; overviewDate: moment.Moment }>()
);

export const ClearSchoolActivityInstancesOverviewAction = createAction(
	'[SchoolActivities] Clear SchoolActivityInstancesOverview',
	props<{
		scheduleType: SchoolActivityScheduleType;
		flexPeriodId?: number;
		overviewDate: moment.Moment;
	}>()
);
